import { type FC } from 'react'

import { FireworkLogoAndText } from '@core/assets/FireworkLogoAndText'

import type { FireworkBrandingProps } from './FireworkBranding.types'

/**
 * Provides the firework branding
 *  - Displays the `Powered by` text and logo in English
 *  - Only displays the logo in other languages
 */
export const FireworkBranding: FC<FireworkBrandingProps> = ({
  dark,
  utmContent,
  lang,
  size = 'small',
}) => {
  return (
    <a
      href={`https://firework.com/video-solutions-for-entrepreneurs/?utm_source=${
        window?.location?.hostname ?? 'unknownHostname'
      }&utm_medium=branding_referrals&utm_campaign=oto&utm_content=${utmContent}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
      }}
    >
      {lang === 'en' && (
        <span
          style={{
            fontFamily: 'Epilogue',
            fontWeight: 'var(--font-medium)',
            fontSize: size === 'large' ? '13px' : '9px',
            color: dark ? 'var(--gray-8)' : 'white',
          }}
        >
          {'Powered by'}
        </span>
      )}
      <FireworkLogoAndText
        label={'Firework'}
        style={{
          height: size === 'large' ? '16px' : '12px',
          margin: '0 1px',
          color: dark ? 'var(--gray-8)' : 'white',
        }}
      />
    </a>
  )
}

export default FireworkBranding
